import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { expenseKeys } from '@/lib/query-keys';
import { expenseService } from '@/services/expense.service';

export function useExpenseApprovals() {
  const queryClient = useQueryClient();

  const approvalsQuery = useQuery({
    queryKey: expenseKeys.pendingApprovals(),
    queryFn: () => expenseService.getPendingApprovals(),
  });

  const approveExpense = useMutation({
    mutationFn: ({ id, comment }: { id: string; comment?: string }) => expenseService.approve(id, comment),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: expenseKeys.all }); toast.success('Expense approved'); },
    onError: () => toast.error('Failed to approve expense'),
  });

  const rejectExpense = useMutation({
    mutationFn: ({ id, comment }: { id: string; comment?: string }) => expenseService.reject(id, comment),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: expenseKeys.all }); toast.success('Expense rejected'); },
    onError: () => toast.error('Failed to reject expense'),
  });

  const reimburseExpense = useMutation({
    mutationFn: (id: string) => expenseService.reimburse(id),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: expenseKeys.all }); toast.success('Expense reimbursed'); },
    onError: () => toast.error('Failed to reimburse expense'),
  });

  return {
    pendingApprovals: approvalsQuery.data?.data ?? [],
    isLoading: approvalsQuery.isLoading,
    approveExpense, rejectExpense, reimburseExpense,
  };
}
